import { render, staticRenderFns } from "./TodayVisit.vue?vue&type=template&id=0bb800a2&scoped=true"
import script from "./TodayVisit.vue?vue&type=script&lang=js"
export * from "./TodayVisit.vue?vue&type=script&lang=js"
import style0 from "./TodayVisit.vue?vue&type=style&index=0&id=0bb800a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb800a2",
  null
  
)

export default component.exports